export default __webpack_public_path__ + "static/media/about-2.175b518c.png";